export const contingentArrowDownIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 6"><path d="M6 5.5a.75.75 0 01-.464-.158L0 .993.929 0 6 3.985 11.071 0 12 .993l-5.536 4.35A.75.75 0 016 5.5z" fill="#9CBAC7"/></svg>`,
  name: 'arrow-down',
};
